import i18n from 'modules/core/lib/i18n'

import Item from 'modules/contracts/components/ContractDetails/LegalAndLabour/Item'

interface Props {
  niveau?: string
}

const Niveau = ({ niveau }: Props) => {
  return (
    <Item
      title={i18n.t('contract_versions.legal_and_labour.france.niveau')}
      description={niveau}
      capitalize={false}
    />
  )
}

export default Niveau
